"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TermFunctionStrBefore = void 0;
const bus_function_factory_1 = require("@comunica/bus-function-factory");
const utils_expression_evaluator_1 = require("@comunica/utils-expression-evaluator");
const Helpers_1 = require("@comunica/utils-expression-evaluator/lib/functions/Helpers");
/**
 * https://www.w3.org/TR/sparql11-query/#func-strbefore
 */
class TermFunctionStrBefore extends bus_function_factory_1.TermFunctionBase {
    constructor() {
        super({
            arity: 2,
            operator: utils_expression_evaluator_1.SparqlOperator.STRBEFORE,
            overloads: (0, utils_expression_evaluator_1.declare)(utils_expression_evaluator_1.SparqlOperator.STRBEFORE)
                .onCompatibleStringly2(() => (arg1, arg2) => {
                const [a1, a2] = [arg1.typedValue, arg2.typedValue];
                const sub = a1.slice(0, Math.max(0, a1.indexOf(a2)));
                if (sub || !a2) {
                    if (arg1.dataType === utils_expression_evaluator_1.TypeURL.RDF_LANG_STRING) {
                        return (0, utils_expression_evaluator_1.langString)(sub, arg1.language);
                    }
                    if (arg1.dataType === utils_expression_evaluator_1.TypeURL.RDF_DIR_LANG_STRING) {
                        return (0, Helpers_1.dirLangString)(sub, arg1.language, arg1.direction);
                    }
                    return (0, utils_expression_evaluator_1.string)(sub, arg1.dataType);
                }
                return (0, utils_expression_evaluator_1.string)(sub);
            })
                .collect(),
        });
    }
}
exports.TermFunctionStrBefore = TermFunctionStrBefore;
//# sourceMappingURL=TermFunctionStrBefore.js.map